export { default as CompleteInfo } from 'auth/containers/CompleteInfoContainer';
export { default as UpdateInfo } from 'auth/containers/UpdateInfoContainer';
export { default as Login } from 'auth/containers/LoginContainer';
export { default as Logout } from 'auth/containers/LogoutContainer';
export { default as RecoverPassword } from 'auth/containers/RecoverPasswordContainer';
export { default as ResetPassword } from 'auth/containers/ResetPasswordContainer';



// WEBPACK FOOTER //
// src/modules/auth/containers/index.js